import UploadIcon from "@mui/icons-material/Upload";
import { Paper, Typography } from "@mui/material";
import React from "react";
import Dropzone from "react-dropzone";

function UploadDropzone(props) {
  return (
    <Dropzone
      onDrop={props.onDrop}
      disabled={props.disabled ?? false}
      multiple={false}
      accept={{ "image/*": [".png", ".jpeg", ".jpg", ".webp"] }}
    >
      {({ getRootProps, getInputProps }) => (
        <section>
          <Paper
            {...getRootProps()}
            style={{
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "2px dashed gray",
              borderRadius: 20,
              cursor: props.disabled ? "not-allowed" : "pointer",
              padding: 20,
              backgroundImage: "url(/images/backdrop_inverse.webp)",
              backgroundSize: "cover",
              opacity: props.disabled ? 0.5 : 1,
            }}
          >
            <input {...getInputProps()} />
            <UploadIcon style={{ fontSize: 100 }} />
            <Typography variant="h4">Drag a design here or click to upload</Typography>
          </Paper>
        </section>
      )}
    </Dropzone>
  );
}

export default UploadDropzone;
